import type { ReactNode } from 'react';

const steps = [
  { label: 'Chọn món', icon: 'menu' },
  { label: 'Chọn mood', icon: 'mood' },
  { label: 'Thanh toán', icon: 'payment' },
  { label: 'Nhận thông điệp', icon: 'message' },
] as const;

function StepIcon({ name }: { name: (typeof steps)[number]['icon'] }) {
  const paths: Record<(typeof steps)[number]['icon'], ReactNode> = {
    menu: (
      <>
        <path d="M7 5.5h10v13H7zM10 3.5h4v4h-4z" />
        <path d="m10 12 1.5 1.5L15 10" />
      </>
    ),
    mood: (
      <>
        <circle cx="12" cy="12" r="8" />
        <path d="M9 10h.01M15 10h.01M8.5 14.5c1 1.1 2.1 1.6 3.5 1.6s2.5-.5 3.5-1.6" />
      </>
    ),
    payment: (
      <>
        <circle cx="12" cy="12" r="8" />
        <path d="M8.5 8.5h7v7h-7zM10 12h4M12 10v4" />
      </>
    ),
    message: (
      <>
        <rect x="7" y="4" width="10" height="16" rx="2" />
        <path d="M10 7h4M9.5 11h5v4h-3l-2 2v-2Z" />
      </>
    ),
  };

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {paths[name]}
    </svg>
  );
}

function BotanicalDecoration() {
  return (
    <svg className="qr-botanical" viewBox="0 0 150 260" aria-hidden="true" focusable="false">
      <path d="M18 250C32 184 62 123 127 28" />
      <path d="M35 201C9 191 3 169 8 143c26 10 39 28 27 58ZM51 166c-5-30 10-51 36-66 8 29-2 52-36 66ZM75 126c-3-29 13-49 39-61 5 28-7 49-39 61ZM94 89c2-26 16-43 41-52 1 26-12 44-41 52Z" />
      <path d="M29 220c28-7 48 3 63 28-29 9-50 0-63-28ZM47 180c27-5 47 7 59 32-28 7-48-4-59-32ZM69 139c25-3 43 8 54 31-26 6-45-5-54-31Z" />
    </svg>
  );
}

function DecorativePhone() {
  return (
    <div className="decorative-phone">
      <span className="phone-speaker" />
      <small>Dream Up</small>
      <div className="decorative-qr" data-decorative-qr="true">
        <i />
        <i />
        <i />
        <i />
        <i />
        <i />
        <i />
        <i />
        <i />
      </div>
      <strong>Chọn mood</strong>
      <span className="phone-action">Gợi ý món</span>
    </div>
  );
}

function DecorativeCup() {
  return (
    <div className="decorative-cup">
      <span className="cup-rim">
        <i />
        <i />
        <i />
      </span>
      <div className="cup-brand">
        <strong>DREAM UP</strong>
        <span aria-hidden="true">✦</span>
        <small>Dám Mơ Lại</small>
        <small>Dám Bắt Đầu</small>
      </div>
    </div>
  );
}

export function QrOrderBanner() {
  return (
    <section className="qr-order-banner" id="qr-order" aria-labelledby="qr-order-heading">
      <BotanicalDecoration />
      <div className="qr-banner-copy">
        <h2 id="qr-order-heading">SCAN QR – CHỌN MOOD</h2>
        <p>
          Nhận thông điệp tích cực
          <br />
          dành riêng cho bạn
        </p>
        <ol aria-label="Các bước trải nghiệm QR Order">
          {steps.map((step) => (
            <li key={step.label}>
              <span className="qr-step-icon">
                <StepIcon name={step.icon} />
              </span>
              <span>{step.label}</span>
            </li>
          ))}
        </ol>
      </div>

      <div className="qr-banner-art" aria-hidden="true">
        <span className="decorative-hand" />
        <DecorativePhone />
        <DecorativeCup />
      </div>

      <div className="qr-banner-message">
        <blockquote>
          Mỗi ly nước
          <br /> là một thông điệp
          <br /> tiếp thêm động lực
        </blockquote>
        <svg viewBox="0 0 120 72" aria-hidden="true" focusable="false">
          <path d="M42 26C25 8 8 20 12 36c4 14 30 27 30 27s26-13 30-27C76 20 59 8 42 26Z" />
          <path d="M63 61c20-9 32-23 43-45M77 51c11 0 19 4 24 12M87 39c10-1 18 2 24 9M96 27c7 0 12 2 17 7" />
        </svg>
      </div>
    </section>
  );
}
